import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'routing-servers-groups-settings-search',
  templateUrl: './routing-servers-groups-settings-search.component.html',
  styleUrls: ['./routing-servers-groups-settings-search.component.scss']
})
export class RoutingServersGroupsSettingsSearchComponent implements OnInit {

  onApply = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<RoutingServersGroupsSettingsSearchComponent>, @Inject(MAT_DIALOG_DATA) public search: any) {
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }

}
